/** Align with backend constants/permissions.js and mst_submodules.submodule_slug */
export const MAINTENANCE_RECORDS_CONTROL_SUBMODULE_SLUG = "maintenance-records-control";
export const MAINTENANCE_RECORDS_SUBMODULE_SLUG = "maintenance-records";
